import { render, staticRenderFns } from "./DefinitiveShow.vue?vue&type=template&id=1dc43eaa&scoped=true&"
import script from "./DefinitiveShow.vue?vue&type=script&lang=js&"
export * from "./DefinitiveShow.vue?vue&type=script&lang=js&"
import style0 from "./DefinitiveShow.vue?vue&type=style&index=0&id=1dc43eaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc43eaa",
  null
  
)

export default component.exports